"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContext = void 0;
var react_1 = require("react");
var React = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var remove_ships_every_text_1 = __importDefault(require("../../../../utils/remove-ships-every-text"));
var api_1 = require("../../api");
var crumb_nav_1 = __importDefault(require("../../components/crumb_nav"));
var utils_1 = require("../../utils");
var select_reason_1 = __importDefault(require("./components/select-reason"));
var nav_button_1 = __importDefault(require("./components/nav-button"));
var select_refund_1 = __importDefault(require("./components/select-refund"));
var confirm_cancel_1 = __importDefault(require("./components/confirm-cancel"));
var cancel_order_1 = require("../../mutations/cancel-order");
exports.AppContext = (0, react_1.createContext)({
    cancelReason: { key: '', name: undefined },
    setCancelReason: function (reason) { return undefined; },
    setRefundType: function (refundType) { return undefined; },
    submitCancel: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, undefined];
    }); }); },
    orderToCancel: undefined,
    goToNextStep: function () { return undefined; },
    resetToFirstStep: function () { return undefined; },
    isFinalStep: false,
    canGoNext: false,
    refundType: undefined,
    pathNext: undefined,
    isReadyForSubmit: false,
    isCancellingOrder: false,
    mainBundleProduct: undefined,
    products: undefined,
    orderIsCancelled: false,
    attemptedCancel: false,
});
exports.default = (function (_a) {
    var isLoadingAccountData = _a.isLoadingAccountData, orders = _a.orders;
    var orderId = (0, react_router_dom_1.useParams)().orderId;
    var path = (0, react_router_dom_1.useRouteMatch)().path;
    var location = (0, react_router_dom_1.useLocation)();
    var history = (0, react_router_dom_1.useHistory)();
    var _b = __read((0, react_1.useState)({ key: '', name: undefined }), 2), cancelReason = _b[0], setCancelReason = _b[1];
    var _c = __read((0, react_1.useState)('creditCard'), 2), refundType = _c[0], setRefundType = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isCancellingOrder = _d[0], setIsCancellingOrder = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), orderIsCancelled = _e[0], setOrderIsCancelled = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), attemptedCancel = _f[0], setAttemptedCancel = _f[1];
    // skip the choose refund type step
    var skipRefundTypeStep = true;
    var subscriptionsApiClient = (0, api_1.getSubscriptionAPIClient)();
    var _g = (0, react_query_1.useMutation)(function (variables) { return subscriptionsApiClient.request(cancel_order_1.CANCEL_ORDER, variables); }, {
        onSuccess: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setOrderIsCancelled(true);
                setAttemptedCancel(true);
                setIsCancellingOrder(false);
                history.push("".concat(orderCancelPath, "/confirm"));
                return [2 /*return*/];
            });
        }); },
        onError: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setAttemptedCancel(true);
                setIsCancellingOrder(false);
                history.push("".concat(orderCancelPath, "/confirm"));
                return [2 /*return*/];
            });
        }); },
    }), cancelOrder = _g.mutateAsync, isSubmitting = _g.isLoading;
    (0, react_1.useEffect)(function () {
        // set isCancellingOrder here in useEffect (as opposed to relying on isSubmitting)
        // so that button doesn't reset to be clickable after mutation
        if (isSubmitting) {
            setIsCancellingOrder(true);
        }
    }, [isSubmitting]);
    (0, react_1.useEffect)(function () {
        var footer = document.getElementById('footer');
        if (footer)
            footer.style.display = 'none';
        (0, utils_1.hideThirdPartyButtons)();
    }, []);
    var orderToCancel = (0, react_1.useMemo)(function () {
        return orders === null || orders === void 0 ? void 0 : orders.find(function (order) { return order.id === Number(orderId); });
    }, [orders, orderId]);
    var mainBundleProductTitles = ['Diaper Bundle', 'Vitamin Bundle', 'Fundamentals Bundle'];
    var mainBundleProduct = (0, react_1.useMemo)(function () { return orderToCancel === null || orderToCancel === void 0 ? void 0 : orderToCancel.line_items.find(function (lineItem) { return mainBundleProductTitles.includes((0, remove_ships_every_text_1.default)(lineItem.title)); }); }, [orderToCancel]);
    var products = (0, react_1.useMemo)(function () { return orderToCancel === null || orderToCancel === void 0 ? void 0 : orderToCancel.line_items.filter(function (lineItem) { return !mainBundleProductTitles.includes((0, remove_ships_every_text_1.default)(lineItem.title)); }); }, [orderToCancel]);
    var orderCancelPath = (0, react_1.useMemo)(function () {
        return "/orders/cancel/".concat(orderId);
    }, [orderId]);
    var pathBack = (0, react_1.useMemo)(function () {
        switch (location.pathname) {
            case "".concat(orderCancelPath, "/refund"):
                return orderCancelPath;
        }
    }, [location.pathname]);
    var isFinalStep = (0, react_1.useMemo)(function () {
        return skipRefundTypeStep && location.pathname === orderCancelPath;
    }, [location.pathname]);
    var pathNext = (0, react_1.useMemo)(function () {
        switch (location.pathname) {
            case orderCancelPath && !isFinalStep:
                return "".concat(orderCancelPath, "/refund");
        }
    }, [location.pathname]);
    var isReadyForSubmit = (0, react_1.useMemo)(function () {
        return !pathNext && !!cancelReason.name && !!refundType;
    }, [location.pathname, refundType, cancelReason]);
    var canGoNext = (0, react_1.useMemo)(function () {
        switch (location.pathname) {
            case orderCancelPath:
                return !isFinalStep && cancelReason && cancelReason.key !== '';
            case "".concat(orderCancelPath, "/refund"):
                return false;
            default:
                return false;
        }
    }, [cancelReason, location.pathname]);
    var submitCancel = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!orderToCancel)
                        return [2 /*return*/];
                    return [4 /*yield*/, cancelOrder({ shopifyOrderId: orderToCancel.id, refundType: refundType, cancelReason: cancelReason.key })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var goToNextStep = (0, react_1.useMemo)(function () {
        return function () {
            if (canGoNext && pathNext) {
                history.push(pathNext);
            }
        };
    }, [canGoNext, pathNext]);
    // used to reset to the reasons page if going directly to `/refund` or `/confirm` without having picked a cancel reason
    var resetToFirstStep = function () {
        history.push(orderCancelPath);
    };
    var crumbNavHeader = (React.createElement(crumb_nav_1.default, { current: React.createElement("div", { className: 'padding-left-10', style: { textAlign: 'left' } }, pathBack ? 'Back' : 'My Account'), backLink: pathBack }));
    if (isLoadingAccountData) {
        return null;
    }
    if (!isLoadingAccountData && !orders) {
        return (React.createElement("div", null,
            crumbNavHeader,
            React.createElement("div", null, "Something went wrong...")));
    }
    if (!(orderToCancel === null || orderToCancel === void 0 ? void 0 : orderToCancel.is_cancellable)) {
        return (React.createElement("div", null,
            crumbNavHeader,
            React.createElement("div", { className: 'margin-top-10 padding-10 bordered bg-white' }, "Sorry, you cannot cancel this order.")));
    }
    var contextValue = {
        orderToCancel: orderToCancel,
        setCancelReason: setCancelReason,
        setRefundType: setRefundType,
        cancelReason: cancelReason,
        goToNextStep: goToNextStep,
        resetToFirstStep: resetToFirstStep,
        isFinalStep: isFinalStep || !pathNext,
        isCancellingOrder: isCancellingOrder,
        canGoNext: canGoNext,
        refundType: refundType,
        isReadyForSubmit: isReadyForSubmit,
        submitCancel: submitCancel,
        pathNext: pathNext,
        mainBundleProduct: mainBundleProduct,
        products: products,
        orderIsCancelled: orderIsCancelled,
        attemptedCancel: attemptedCancel,
    };
    // need a scroll container const to target for scrolling to content top
    var scrollContainerDivID = 'cancel-order-container';
    (0, react_1.useMemo)(function () {
        var el = document.getElementById(scrollContainerDivID);
        if (el) {
            el.scrollTop = 0;
        }
    }, [location.pathname]);
    return (React.createElement(exports.AppContext.Provider, { value: contextValue },
        crumbNavHeader,
        React.createElement("div", { className: 'padding-bottom-15', id: scrollContainerDivID },
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_dom_1.Route, { exact: true, path: path },
                    React.createElement(select_reason_1.default, null)),
                React.createElement(react_router_dom_1.Route, { path: "".concat(path, "/refund") },
                    React.createElement(select_refund_1.default, null)),
                React.createElement(react_router_dom_1.Route, { exact: true, path: "".concat(path, "/confirm") },
                    React.createElement(confirm_cancel_1.default, null)))),
        React.createElement("div", { className: 'position-fixed-bottom text-center' },
            React.createElement(nav_button_1.default, null))));
});
